export const setRouterVisit = (activeRoute) => {
    try {
      // 取出页签对象
      let visitRouterSessionStorage = sessionStorage.getItem('visitRouterSessionStorage')
      if (visitRouterSessionStorage && visitRouterSessionStorage !== '[]') {
        // 转对象
        visitRouterSessionStorage = JSON.parse(visitRouterSessionStorage)
        // 寻找路由是否在当前缓存中
        let isExsit = visitRouterSessionStorage.find((item) => item.path === activeRoute.path)
        if (!isExsit) {
          // 没有追加，路由对象并缓存
          visitRouterSessionStorage.push({
            path: activeRoute.path,
            name: activeRoute.name,
            meta: activeRoute.meta,
            title: activeRoute.meta.title
          })
          sessionStorage.setItem('visitRouterSessionStorage', JSON.stringify(visitRouterSessionStorage))
          // this.activeMenu = visitRouterSessionStorage
        }
      } else {
        // sessionStorage.clear()
        // visitRouterSessionStorage 对象被清除了，重置页签缓存，切勿丢失页签缓存对象
        sessionStorage.setItem('visitRouterSessionStorage', '[]')
        // 跳转后的当前页面
        let visitRouter = {
          path: activeRoute.path,
          name: activeRoute.name,
          meta: activeRoute.meta,
          title: activeRoute.meta.title
          
        }
        // 同步缓存
        sessionStorage.setItem('visitRouterSessionStorage', JSON.stringify([visitRouter]))
        // 同步响应式对象
        // this.activeMenu = [visitRouter]
      }
      // this.activeViews = (JSON.parse(sessionStorage.getItem('visitRouterSessionStorage')) || []).map(
      //   (item) => item.name
      // )
    } catch (e) {
      // this.activeMenu = []
      // this.activeViews = []
      sessionStorage.setItem('visitRouterSessionStorage', '[]')
      window.location.reload()
    }
  }
  
  export const removeRouterVisit = (activeRoute) => {
    let visitRouterSessionStorage = sessionStorage.getItem('visitRouterSessionStorage')
    if (visitRouterSessionStorage && visitRouterSessionStorage !== '[]') {
      // 转对象
      visitRouterSessionStorage = JSON.parse(visitRouterSessionStorage)
      if (Array.isArray(visitRouterSessionStorage)) {
        console.log(activeRoute)
        const index = visitRouterSessionStorage.findIndex((item) => item.path === activeRoute.path)
        visitRouterSessionStorage.splice(index, 1)
        sessionStorage.setItem('visitRouterSessionStorage', JSON.stringify(visitRouterSessionStorage))
        
      }
    }
  }